module.exports = __webpack_public_path__ + "img/hy3.7f40650b.jpg";